import React from 'react'

const SuccessIcon = () => {
  return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <mask id="mask0_5160_17795"  maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
                <rect x="0.666016" width="24" height="24" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_5160_17795)">
                <path d="M10.2156 18.0001L4.51562 12.3001L5.94063 10.8751L10.2156 15.1501L19.3906 5.9751L20.8156 7.4001L10.2156 18.0001Z" fill="#4BB543"/>
            </g>
        </svg>
  )
}

export default SuccessIcon
